import { useState, useEffect } from 'react';
import { breakpoints } from 'style/config';
import { DebouncedResize } from 'constants/events';

export const useIsSmallView = () => {
    // Initialize to a stable value (false) so server and client-first-render agree,
    // then sync to the real matchMedia result inside useEffect. Avoids hydration mismatch.
    const [isSmallView, setIsSmallView] = useState(false);

    useEffect(() => {
        const handler = () => setIsSmallView(window.matchMedia(breakpoints.xsMax).matches);
        handler();
        window.addEventListener(DebouncedResize, handler);

        return () => window.removeEventListener(DebouncedResize, handler);
    }, []);

    return isSmallView;
};
